var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.downloadFile}},[_vm._v("\n        Download Audio\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }